// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + "wix-payment-methods-banner-demo" + ".chunk.min.css";
};